/**
 * DASHBOARD-TOPIC-HARASSMENT-CHIP.WIDGET
 * Count for harassment
 */

import { withTranslation, WithTranslation } from "react-i18next"
import Chip from "@/components/chip"
import { Topic } from "@/redux/topic.types"
import DashboardQuestionsNoteWidget from "./dashboard-questions-note.widget"

interface OwnProps extends WithTranslation {
  countHarassment: number
  isOutlineColored?: boolean
  currentTopic?: Topic
}

function DashboardTopicHarassmentCountWidget(props: OwnProps) {
  const { t } = props

  return (
    <div className="mr-10 flex">
      {props.currentTopic?.withScore && <DashboardQuestionsNoteWidget currentTopic={props.currentTopic} />}
      {props.countHarassment > 0 ? (
        <Chip isOutlineColored={props.isOutlineColored} color="#eb5a46">
          {t("topic_harassment_count", { count: props.countHarassment })}
        </Chip>
      ) : (
        <Chip color="#20CA7E">{t("topic_harassment_none")}</Chip>
      )}
    </div>
  )
}

export default withTranslation()(DashboardTopicHarassmentCountWidget)
